import React from 'react';
import { CustomArrowProps } from 'react-slick';
import { StyledArrow } from './arrow.style';

export interface IArrowProps extends CustomArrowProps {
    orientation?: 'left' | 'up' | 'right' | 'down';
    size?: 'S' | 'M' | 'L';
}
export const Arrow = ({ currentSlide, slideCount, ...props }: IArrowProps) => (
    <StyledArrow {...props} />
);
